{
  "common": {
    "for": "for",
    "each": "each",
    "eachLot": "Each lot",
    "lot": "lot",
    "lots": "lots",
    "selectAll": "Select All",
    "unselectAll": "Unselect All"
  },
  "pageHeader": {
    "techSupport": "Technical Support",
    "auctionCompany": "Auction Company",
    "welcome": "Welcome",
    "bidder": "Bidder",
    "viewer": "Viewer",
    "fullCatalog": "View Full Catalog"
  },
  "catalogAndMyPurchases": {
    "firstTab": "Catalog",
    "secondTab": "My Purchases",
    "trackLots": "Allow Catalog to track lots",
    "backToLots": "Back to lots",
    "passed": "Passed",
    "pending": "Pending",
    "sold": "Sold",
    "biddingNow": "BIDDING NOW",
    "upNext": "UP NEXT",
    "confirmPurchases": "All purchases must be confirmed by the auction company",
    "lot": "Lot",
    "backToMyPurchases": "Back to My Purchases"
  },
  "chat": {
    "loading": "Loading chat ...",
    "header": "Online Chat"
  },
  "mediaStreaming": {
    "failedConnection": "Connection failed!",
    "playBtn": "Play live media",
    "connecting": "Connecting ...",
    "unmute": "Un-mute",
    "mute": "Mute",
    "tooltip": "You are successfully connected<br/> to the media streaming platform"
  },
  "biddingArea": {
    "auctionPaused": "Auction is paused",
    "waitingAuctionToStart": "Waiting for Auction Event to Start",
    "waitingBiddingToStart": "Waiting for Bidding to Start",
    "auctioneerConfirmed": "The Auctioneer gave you",
    "soldPriceForEach": "Sold price for each",
    "winningBid": "Winning Bid",
    "pendingSellerConfirmationForEach": "Pending seller confirmation price for each",
    "pendingBid": "Pending Bid",
    "auctioneerRefused": "The Auctioneer did not give you any lot.",
    "sold": "Sold!",
    "pendingSellerConfirmation": "Pending seller confirmation.",
    "bid": "Bid",
    "roundCancelled": "Round was cancelled",
    "noSale": "Passed",
    "highestBidder": "Congratulations you are the high bidder!",
    "youWon": "Congratulations! You won",
    "waitingWinner": "Waiting for the winner to choose the lots…",
    "totalPrice": "Total Price",
    "yourBidPending": "Your bid is pending seller confirmation",
    "waitingWinnerChooseLots": "Pending seller confirmation. Waiting for the winner to choose the lots…",
    "youAreIn": "You are in!",
    "viewOnly": "VIEW ONLY! ",
    "registerLogin": "Register/Login ",
    "clickToBid": "Click to Bid ",
    "swipeToBid": "Swipe to Bid ",
    "waitingIncrement": "Waiting for Increment",
    "totalBid": "Total Bid",
    "bidHistory": "Bid History",
    "floorFirst": "FLOOR FIRST",
    "waitAuctioneer": "Please wait for the Auctioneer to confirm your choice.",
    "makeSelections": "Please make your selections",
    "pricePendingConfirmation": "Price pending seller confirmation for each",
    "selectionSent": "Selection sent",
    "sendSelection": "Send selection"
  },
  "currentRound": {
    "nowBidding": "Now Bidding",
    "scrollList": "scroll list below"
  },
  "webcastFinished": "The webcast event has closed. Thank you."
}
